<mis-multi-select-dropdown [data]="dropdownData" [label]="label" [width]="width" [searchEnabled]="true" height="32px"
  [selectedItems]="selectedItems" [showSelectedCount]="false" noDataMessage="No Data" [hideApplyButton]="true"
  [enableSelectAll]="true" (onChange)="checkValue($event)"
  [matTooltip]="customLabel"  [customLabelTemplate]="showSelectedFilter ? temp : null"
  ></mis-multi-select-dropdown>



  <ng-template #temp>
    <div class="text">{{customLabel || label}}</div>
    <div class="count" *ngIf="filterValuesCount">+{{filterValuesCount}}</div>
  </ng-template>


<!-- 
<mis-multi-select-dropdown
  [data]="dropdownData"
  [label]="'label'"
  [searchEnabled]="false"
  [selectedItems]="selectedItems"
  [showSelectedCount]="false"
  [noDataMessage]="'No Data'"
  [hideApplyButton]="true"
  [enableSelectAll]="true"
  (onChange)="checkValue($event)"
></mis-multi-select-dropdown> -->


<!-- <mat-form-field>
  <mat-select [formControl]="selectedValue" multiple (selectionChange)="checkValue($event)">
    <mat-select-trigger style="color: #415366;font-size: 14px;font-family: 'lato';">
      {{selectedValue.value ? labelKey ? this.optionMap[this.selectedValue.value[0]] : selectedValue.value[0] : ''}}
      <span *ngIf="selectedValue.value?.length > 1" class="example-additional-selection">
        (+{{selectedValue.value.length - 1}} {{selectedValue.value?.length === 2 ? 'other' : 'others'}})
      </span>
    </mat-select-trigger>
    <mat-checkbox class="mat-option" [indeterminate]="isIndeterminate()" [checked]="isChecked()"
      (click)="$event.stopPropagation()" (change)="toggleSelection($event)">
      Select All
    </mat-checkbox>
    <mat-option class="mat-options-check" *ngFor="let option of options" [value]="valueKey ? option[valueKey] : option">
      {{labelKey ? option[labelKey] : option}}
    </mat-option>
  </mat-select>
</mat-form-field> -->
<div class="error-msg" style="margin-top: 1px;position:absolute"
  *ngIf="formControl.errors && formControl.errors.required">
  {{errorMessages.required}}</div>